<script setup>
import {
    HpoBodyStatusLabel,
    HpoTransportDestinationRequestStatusLabel,
    HpoTransportStatus,
    HpoTransportStatusLabel
} from "../../../choices";
import {HpoAlertConfirmMutation} from "@/graphql/mutations/hpo/patient/alertConfirm.graphql"
import {useMutation} from "@vue/apollo-composable";
import {computed} from "vue";
import {useBlinking} from "../../../../alert-ticker";

const props = defineProps({
    patient: {
        type: Object,
        required: true
    },
    member: {
        type: Object,
        required: true
    },
    alertList: {
        type: Array,
        required: true
    },
})
const emit = defineEmits(['openReplyModal'])
const {mutate, loading} = useMutation(HpoAlertConfirmMutation)


const isAlert = computed(() => {
    return props.alertList.includes(parseInt(props.patient.id))
})

const isBlinkActive = useBlinking(() => isAlert.value);
const bgColor = computed(() => isBlinkActive.value ? 'red' : null);

const showTransportStatus = computed(() => {
    return !!(props.patient.transportStatus && (
        (props.patient.transportStatus !== HpoTransportStatus.FINISHED) &&
        (props.patient.transportStatus !== HpoTransportStatus.TERMINATED)
    ));
})

const showRequestStatus = computed(() => {
    return !!(props.patient.transportDestinationRequestStatus && props.patient.transportStatus && (
        (props.patient.transportStatus === HpoTransportStatus.DISP_PENDING) ||
        (props.patient.transportStatus === HpoTransportStatus.HOSPITAL_PENDING) ||
        (props.patient.transportStatus === HpoTransportStatus.ON_WAY)
    ));
})

function confirmRead() {
    mutate({patientId: props.patient.id})
}
</script>


<template>
    <v-card :color="bgColor" class="hpo-patients-list__td">
        <div class="hpo-patients-list__td__body hpo-patients-list__td__body--statuses">
            <div class="hpo-patient-list__td__body__status-segment">
                <div>{{ gettext('Patient') }}:</div>
                <div><b>{{ HpoBodyStatusLabel[patient.status] }}</b></div>
            </div>
            <div v-if="showTransportStatus"
                 class="hpo-patient-list__td__body__status-segment">
                <div>{{ gettext('Transport') }}:</div>
                <div><b>{{ HpoTransportStatusLabel[patient.transportStatus] }}</b></div>
            </div>

            <div v-if="showRequestStatus"
                 class="hpo-patient-list__td__body__status-segment">
                <div>{{ gettext('Request status') }}:</div>
                <div><b>{{
                        HpoTransportDestinationRequestStatusLabel[patient.transportDestinationRequestStatus]
                    }}</b></div>
            </div>
            <div v-if="patient.rejectionReason" class="hpo-patient-list__td__body__status-segment">
                <div>{{ gettext('Cancelation reason') }}:</div>
                <div><b>{{ patient.rejectionReason }}</b></div>
            </div>


            <!-- CONFIRM READ BUTTON -->
            <v-btn v-if="isAlert"
                   class="-pa-0"
                   @click="confirmRead()"
                   :disabled="loading"
                   :loading="loading">
                <span class="text-wrap">{{pgettext('action', 'confirm read')}}</span>
            </v-btn>
        </div>
    </v-card>
</template>
